/* Warenkorb-Trust-Badges The Card Club, 18.09.2026 (ersetzt den Countdown)
 * Zahlen: 120 Bewertungen, 4,75 von 5 — identisch mit dem Bewertungsraster auf der Startseite.
 */
(function () {
  var ANCHORS = [
    // 27.10.2026: im Drawer raus (Platz fuer den Artikel), nur noch auf der Warenkorbseite
    { sel: '.cart-form button[name=checkout]', where: 'after' }
  ];
  var ICON = {
    star: '<svg viewBox="0 0 24 24" width="18" height="18" fill="#3B6640"><path d="M12 2.5l2.9 6.2 6.8.8-5 4.7 1.3 6.8L12 17.6 6 21l1.3-6.8-5-4.7 6.8-.8z"/></svg>',
    shield: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#3B6640" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.5l8 3v6c0 5-3.4 8.6-8 10-4.6-1.4-8-5-8-10v-6z"/><path d="M8.5 12l2.3 2.3 4.7-4.8"/></svg>',
    truck: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#3B6640" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 6h11v10H2zM13 10h4l3 3v3h-7z"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="16.5" cy="17.5" r="1.8"/></svg>',
    lock: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#3B6640" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="10.5" width="14" height="10" rx="2"/><path d="M8 10.5V7.5a4 4 0 018 0v3"/></svg>'
  };
  var ITEMS = [
    { i: 'star',   t: '<b>4,75 von 5</b> aus 120 Bewertungen' },
    { i: 'shield', t: '<b>Echtheitsgarantie</b> mit Zertifikat' },
    { i: 'truck',  t: '<b>Versand aus Deutschland</b>' },
    { i: 'lock',   t: '<b>Sicher bezahlen</b> · PayPal, Klarna, Karte' }
  ];

  function css() {
    if (document.getElementById('cc-trust-css')) return;
    var s = document.createElement('style');
    s.id = 'cc-trust-css';
    s.textContent =
      '.cc-trust{display:grid;grid-template-columns:1fr 1fr;gap:8px 12px;margin:12px 0 0;padding:12px 14px;' +
      'border-radius:8px;background:#f4f7f4;border:1px solid #d9e3da;color:#1d2a1e;font-size:13px;line-height:1.3}' +
      '.cc-trust__item{display:flex;align-items:center;gap:8px;min-width:0}' +
      '.cc-trust__item svg{flex:0 0 auto}' +
      '.cc-trust b{font-weight:600}' +
      '@media (max-width:380px){.cc-trust{grid-template-columns:1fr}}';
    document.head.appendChild(s);
  }

  function build() {
    var d = document.createElement('div');
    d.className = 'cc-trust';
    d.setAttribute('data-cc-trust', '1');
    d.innerHTML = ITEMS.map(function (x) {
      return '<div class="cc-trust__item">' + ICON[x.i] + '<span>' + x.t + '</span></div>';
    }).join('');
    return d;
  }

  function mount() {
    css();
    ANCHORS.forEach(function (a) {
      var els = document.querySelectorAll(a.sel);
      for (var k = 0; k < els.length; k++) {
        var el = els[k];
        var sib = a.where === 'after' ? el.nextElementSibling : el.previousElementSibling;
        if (sib && sib.getAttribute && sib.getAttribute('data-cc-trust')) continue;
        el.insertAdjacentElement(a.where === 'after' ? 'afterend' : 'beforebegin', build());
      }
    });
  }

  function start() {
    mount();
    new MutationObserver(function () { mount(); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
